import PropTypes from 'prop-types';
import React, { useState, useCallback } from 'react';

import { isEmpty } from '~/utils/array';

import { Container, ListItem } from './List.styled';
import SearchField from './SearchField';

function List({ items, emptyText, onClick, searchValue, onChange, ...props }) {
  const [values, setValues] = useState(items);

  const filterArray = (array, searchString) => {
    if (!searchString || isEmpty(array)) return array;
    return array.filter(({ title }) =>
      title.toUpperCase().includes(searchString.trim().toUpperCase())
    );
  };

  const filterItems = useCallback((array, searchString) => {
    const filteredArray = filterArray(array, searchString);
    setValues(filteredArray);
  }, []);

  return (
    <Container {...props}>
      {isEmpty(items) ? (
        <p>{emptyText}</p>
      ) : (
        <>
          <SearchField
            placeholder="Pesquise pelo nome"
            searchValue={searchValue}
            onChange={onChange}
            onSearch={() => filterItems(items, searchValue)}
          />
          {values.length <= 0 ? (
            <p>Nenhum aluno encontrado</p>
          ) : (
            values.map((item) => (
              <ListItem key={item.id} onClick={() => onClick(item)}>
                <span>{item.title}</span>
              </ListItem>
            ))
          )}
        </>
      )}
    </Container>
  );
}

List.propTypes = {
  emptyText: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType(PropTypes.string, PropTypes.number),
      title: PropTypes.string,
    })
  ).isRequired,
  searchValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default List;
